import { FC, MouseEvent } from 'react';
import { cx } from '@emotion/css';

import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { PhoenixIcon } from '@phoenix/design-system/frontend/ui/phoenix-icon/phoenix-icon';

import { EditorialCardImage, EditorialCardImageProps } from './editorial-card-image';

export interface EditorialHorizontalCardProps {
  image?: EditorialCardImageProps;
  tag?: string;
  title?: string;
  description?: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  className?: string;
  reverse?: boolean;
  ['data-testid']?: string;
  isLinkOut?: boolean;
}

export const EditorialHorizontalCard: FC<React.PropsWithChildren<EditorialHorizontalCardProps>> = ({
  image,
  tag,
  title,
  description,
  onClick,
  className,
  reverse = false,
  'data-testid': dataTestId,
  isLinkOut = false,
}) => {
  return (
    <article
      className={cx(
        'flex flex-1 items-stretch overflow-hidden rounded-lg border border-secondary-mid bg-primary-white mobileOnly:flex-col miniTabletOnly:flex-col',
        onClick && 'cursor-pointer',
        reverse && 'flex-row-reverse',
        className
      )}
      onClick={onClick}
      data-testid={dataTestId}
      aria-label={title}
    >
      {image && <EditorialCardImage {...image} className={cx('aspect-[16/9] h-full tabletOnly:aspect-[4/3]', image.className)} />}
      <div className="relative flex min-w-1/2 flex-1 flex-col justify-center gap-4 p-6">
        {isLinkOut && <PhoenixIcon className="absolute right-6 top-6 h-4 w-4" icon={getDesignSystemIcon('icon-external-link-16.svg')} />}
        <div className={cx({ 'pr-6': isLinkOut })}>
          {tag && <span className="line-clamp-2 block pb-2 text-secondary-dark stihl-text-highlight-flag">{tag}</span>}
          {title && (
            <h4 title={title} className="line-clamp-2 whitespace-pre-wrap stihl-text-h5-mobile">
              {title}
            </h4>
          )}
        </div>
        {description && (
          <div title={description} className="line-clamp-4 stihl-text-body-default-reg desktop:line-clamp-2">
            {description}
          </div>
        )}
      </div>
    </article>
  );
};
